import Character from "./Character"
import { CLASS_NAMES, DIRS } from "../../utils/constants"

export default class NPCharacter extends Character {
  constructor(id, level, name) {
    super(id, level)
    this.name = name
    this.moveIntentDir = ""
    this.isFollowing = false
    this.isLeading = false
    this.leadingPath = []
    level.scene.events.on('player_moves',  this.onPlayerMoves.bind(this))
    this.personalSpace = 3
  }

  lookUp() {
    this.moveIntentDir = DIRS.UP
    this.alien.play('dwarf_look_up')
  }
  
  onPlayerMoves(nextPos) {
    if(this.isCloseEnough(nextPos) && this.isLeading) {
      if(this.leadingPath.length) {
        const nextPos = this.leadingPath.shift()
        this.calcMoveIntentForLeader(nextPos)
        this.level.moveObject(this, nextPos)
      }
    }
  }

  isCloseEnough(pos) {
    const xDist = Math.abs(this.position.x - pos.x)
    const yDist = Math.abs(this.position.y - pos.y)
    return xDist < this.personalSpace && yDist < this.personalSpace
    // return (
    //   // NORTH
    //   (this.position.x === pos.x && this.position.y - 1 === pos.y) ||
    //   // EAST
    //   (this.position.x + 1 === pos.x && this.position.y === pos.y) ||
    //   // SOUTH
    //   (this.position.x === pos.x && this.position.y + 1 === pos.y) ||
    //   // WEST
    //   (this.position.x - 1 === pos.x && this.position.y === pos.y)
    // )
  }
  calcMoveIntentForLeader(nextPos) {
    this.moveIntentDir = this.position.y < nextPos.y ? DIRS.DOWN : this.moveIntentDir
    this.moveIntentDir = this.position.y > nextPos.y ? DIRS.UP : this.moveIntentDir
    if (this.position.x < nextPos.x) {
      this.moveIntentDir = DIRS.LEFT
      this.animRunRight()
    }
    if (this.position.x > nextPos.x) {
      this.moveIntentDir = DIRS.RIGHT
      this.animRunLeft()
    }

    // this.moveObject(follower, followerNextPos)

    // if(this.moveIntentDir === DIRS.UP) {
    //   this.alien.depth = 20
    //   player.alien.depth = 0
    // } else {
    //   player.alien.depth = 20
    //   this.alien.depth = 0
    // }
  }

  destroy() {
    // animate die

  }
  animIdle() {
    this.alien?.play(`${this.name}_idle`)
  }

  animRun() {
    let animRunVariant = ""
    if (this.moveIntentDir === DIRS.UP) {
      animRunVariant = "_up"
    }
    if (this.moveIntentDir === DIRS.DOWN) {
      animRunVariant = "_down"
    }
    const animName = `${this.name}_run${animRunVariant}`
    if (this.alien.anims.currentAnim.key !== animName) {
      this.alien.play(animName)
    }
  }
  animRunLeft(){
    this.alien.setFlipX(true)
    this.alien.setOrigin(0.25, 0.25)
  }
  animRunRight(){
    this.alien.setFlipX(false)
    this.alien.setOrigin(0, 0.25)
  }
  animLayRight() {
    this.alien?.setFlipX(false)
    this.alien?.play(`${this.name}_laying`)
  }
  animLayLeft() {
    this.alien?.setFlipX(true)
    this.alien?.play(`${this.name}_laying`)
  }

  die() {
    this.inactive = true
    this.alien.alpha = 0
    this.level.scene.events.off('player_moves',  this.onPlayerMoves)
    this.destroy()
    // this.level.onCharacterDie(this)
  }

  overrunBy(el) {
    if (el.isClass(CLASS_NAMES.BOULDER)) {
      this.level.scene.events.emit("sounds:death_by_rock_hit")
    }
    if (!el.isClass(CLASS_NAMES.PLAYER)) {
      this.die()
    }
  }
  runningOver(el) {
    if (el.isClass(CLASS_NAMES.ENEMY)) {
      this.die()
    }
    // this.isBrakingGround = el.isClass(Ground.className)
  }
}

NPCharacter.className = CLASS_NAMES.NPC
